module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "main-left"
  }, [_c('side-nav')], 1), _vm._v(" "), _c('div', {
    staticClass: "main-right"
  }, [_c('b-container', {
    staticClass: "mt-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view', [_c('h1', [_vm._v("Dashboard")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1328d797","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = 753
// module chunks = 1